export default "__VITE_ASSET__KxTYJ2$d__"